import { call, put, all } from 'redux-saga/effects';
import { map, get, isArray } from 'lodash';

import { prepareRequestData, getRequestEndpoint } from '../utils';
import { serverRequestSaga } from './serverRequestSaga';
import { signDocumentsFailure, signDocumentsSuccess } from '../../../redux/sentToGp3/actions';

const inventoryDocId = '1184002';

export function* serverSignSaga(action) {
  const {
    docId,
    sendDeclaration: customServerSignRequest,
    responseData,
    attachments,
    password,
    signTogether,
  } = action.payload;

  const versionServerSignRequest = get(customServerSignRequest, 'version', '');
  // transformations data for sending to gp3
  const request = yield call(prepareRequestData, responseData, attachments, password, signTogether);

  try {
    const inventory = get(request, 'inventory');

    //some endpoint could work only with single document. For them we need to extract document from array.
    const issues = isArray(responseData) ? get(request, 'issues') : get(request, 'issues.[0]');

    yield all(
      map(inventory, (inventoryDoc) => {
        const endpoint = getRequestEndpoint();
        return call(serverRequestSaga, endpoint, inventoryDoc, inventoryDocId);
      }),
    );

    const endpoint = getRequestEndpoint(customServerSignRequest);
    yield call(serverRequestSaga, endpoint, issues, docId, versionServerSignRequest);
  } catch (error) {
    return yield put(signDocumentsFailure(error.message));
  }

  return yield put(signDocumentsSuccess());
}
